import { render } from "./EnterLoad.vue?vue&type=template&id=65751e1e&ts=true"
import script from "./EnterLoad.vue?vue&type=script&lang=ts"
export * from "./EnterLoad.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__